const WithProps = ({ children, ...props }) => children(props);

export default WithProps;